import React from "react";
import LeftBox from "./LeftBox";
import RightBox from "./RightBox";

const CategoryComponent = ({
  className,
  leftBoxProps,
  rightBoxProps,
  show,
  showLeft = true,
}) => {
  const leftTextColor = leftBoxProps?.customTextColor;
  const rightTextColor = rightBoxProps?.customTextColor;
  
  return (
    <>
      <div className={`category-container ${className}`}>
        {showLeft && <LeftBox {...leftBoxProps} show={show} customTextColor={leftTextColor} />}
        <RightBox
          {...rightBoxProps}
          impactTotals={rightBoxProps?.impactTotals}
          customTextColor={rightTextColor}
        />
      </div>
    </>
  );
};

export default CategoryComponent;
